import * as React from "react";
import { Box, Paper, Typography } from "@mui/material";
import { AccessTime, DoneAll, HourglassBottom, FolderCopyOutlined } from "@mui/icons-material";
import { translate } from "../../../../../translate/translate";
import { NpiActivity, NpiActivityStatus, NpiProject } from "../types/npi-project.types";

interface NpiDashboardSummaryProps {
  total_projects: number;
  total_steps: number;
  steps_finished: number;
  steps_in_progress: number;
  steps_pending: number;
}

interface SummaryCardProps {
  label: string;
  value: React.ReactNode;
  icon: React.ReactNode;
  iconBackground: string;
  valueColor: string;
}

const SummaryCard = ({ label, value, icon, iconBackground, valueColor }: SummaryCardProps) => (
  <Paper
    variant="outlined"
    sx={{ flex: 1, minWidth: 220, display: "flex", alignItems: "center", gap: 2, p: 1.5, borderRadius: "12px" }}>
    <Box
      sx={{
        width: 48,
        height: 48,
        borderRadius: "10px",
        backgroundColor: iconBackground,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
      }}>
      {icon}
    </Box>
    <Box>
      <Typography sx={{ fontSize: "11px", fontWeight: 700, letterSpacing: "0.08em", color: "#64748B" }}>
        {label.toUpperCase()}
      </Typography>
      <Typography sx={{ fontSize: "28px", fontWeight: 800, lineHeight: 1.2, color: valueColor }}>{value}</Typography>
    </Box>
  </Paper>
);

const sum = (projects: NpiProject[], pick: (project: NpiProject) => number) =>
  projects.reduce((total, project) => total + pick(project), 0);

const countByStatus = (activities: NpiActivity[], statuses: NpiActivityStatus[]) =>
  activities.filter((activity) => statuses.includes(activity.status)).length;

const NpiDashboardSummaryComponent = ({
    total_projects,
    total_steps,
    steps_finished,
    steps_in_progress,
    steps_pending
}: NpiDashboardSummaryProps) => {
  // const totalSteps = sum(projects, (project) => project.totalSteps ?? 0);
  // const completedSteps = sum(projects, (project) => project.completedSteps ?? 0);
  // Conta a partir das células exibidas no board, para o card bater com o que aparece na tela
  // const inProgress = activities
  //     ? countByStatus(activities, ["em_andamento"])
  //     : sum(projects, (project) => project.inProgressActivities ?? 0);
  // const notStarted = activities
  //     ? countByStatus(activities, ["nao_iniciada"])
  //     : sum(projects, (project) => project.notStartedActivities ?? 0);

  return (
    <Box sx={{ display: "flex", flexWrap: "wrap", gap: 2, mb: 2 }}>
      <SummaryCard
        label={translate.t("total_projects")}
        value={total_projects}
        icon={<FolderCopyOutlined sx={{ color: "#7C3AED" }} />}
        iconBackground="#EDE9FE"
        valueColor="#1B1F27"
      />
      <SummaryCard
        label={translate.t("completed_steps")}
        value={`${steps_finished}/${total_steps}`}
        icon={<DoneAll sx={{ color: "#16A34A" }} />}
        iconBackground="#DCFCE7"
        valueColor="#16A34A"
      />
      <SummaryCard
        label={translate.t("in_progress_summary")}
        value={steps_in_progress}
        icon={<HourglassBottom sx={{ color: "#2563EB" }} />}
        iconBackground="#DBEAFE"
        valueColor="#2563EB"
      />
      <SummaryCard
        label={translate.t("pending_not_started")}
        value={steps_pending}
        icon={<AccessTime sx={{ color: "#64748B" }} />}
        iconBackground="#F1F5F9"
        valueColor="#64748B"
      />
    </Box>
  );
};

export default NpiDashboardSummaryComponent;
